import api from '../service/service'
import Swal from 'sweetalert2'
import Chart from 'chart.js'
import familyTable from '../components/modal/family_lncome'
export default {
  name: 'income_analyze',
  data () {
    return {
      People_count: 0,
      Family_count: 0,
      year: new Date().getFullYear(),
      myChartIncome: '',
      listreport: [],
      yearlist: [],
      sumincome: 0,
      sumbalnce: 0,
      sumdebt: 0,
      sumexp: 0,
      trendline: {
        year: new Date().getFullYear(),
        yeartemp: new Date().getFullYear(),
        month: this.getTwoDigitDateFormat(new Date().getMonth() + 1),
        monthtemp: this.getTwoDigitDateFormat(new Date().getMonth() + 1),
        yearbefore: this.getyearbefore(),
        yearbeforetemp: this.getyearbefore(),
        monthbefore: this.getMonthbefore(new Date().getMonth() + 1),
        monthbeforetemp: this.getMonthbefore(new Date().getMonth() + 1)
      },
      test1: [],
      family_id: '',
      test: {
        result: true,
        date: '2019-',
        data: [
          {
            date: '2019-06',
            family_id: '1',
            address_number: '88',
            moo_name: 'แม่ขี้มูก',
            moo_number: '5',
            tambon: 'บ้านทับ',
            district: 'แม่แจ่ม',
            province: 'เชียงใหม่',
            zipcode: '50270',
            income: 2900,
            expenditure: 1400,
            debt: 8000,
            balance: -5100
          },
          {
            date: '2019-04',
            family_id: '1',
            address_number: '88',
            moo_name: 'แม่ขี้มูก',
            moo_number: '5',
            tambon: 'บ้านทับ',
            district: 'แม่แจ่ม',
            province: 'เชียงใหม่',
            zipcode: '50270',
            income: 2900,
            expenditure: 1400,
            debt: 8000,
            balance: -5100
          },
          {
            date: '2019-06',
            family_id: '12',
            address_number: '255',
            moo_name: 'แม่ขี้มูก',
            moo_number: '5',
            tambon: 'บ้านทับ',
            district: 'แม่แจ่ม',
            province: 'เชียงใหม่',
            zipcode: '50270',
            income: 1000,
            expenditure: 2000,
            debt: 3000,
            balance: -2000
          }
        ]
      }
    }
  },
  components: {
    familyTable
  },
  methods: {
    changemonthbefore (e) {
      this.getReport('mb')
    },
    changeyear (e) {
      this.getReport('y')
    },
    changeyearbefore (e) {
      this.getReport('yb')
    },
    handleChange (e) {
      this.getReport('m')
    },
    get () {
      var d = new Date(this.trendline.year, parseInt(this.trendline.month), 0).getDate()
      var end = this.trendline.year + '-' + this.trendline.month + '-' + d
      console.log(end)
    },
    getyearbefore () {
      if (this.getTwoDigitDateFormat(new Date().getMonth() + 1) === '01') {
        return new Date().getFullYear() - 1
      } else {
        return new Date().getFullYear()
      }
    },
    getMonthbefore (val) {
      if (this.getTwoDigitDateFormat(val) === '01') {
        return '11'
      } else if (this.getTwoDigitDateFormat(val) === '02') {
        return '12'
      } else {
        val -= 2
        return val < 10 ? '0' + val : '' + val
      }
    },
    getTwoDigitDateFormat (monthOrDate) {
      return monthOrDate < 10 ? '0' + monthOrDate : '' + monthOrDate
    },
    getfullyear () {
      return new Date().getFullYear()
    },
    getyear () {
      var d = new Date()
      for (let i = d.getFullYear(); i >= d.getFullYear() - 50; i--) {
        this.yearlist.push(i)
      }
      console.log(this.yearlist)
    },
    getFamily () {
      api.getFamilyCount(
        result => {
          if (result.result === true) {
            this.Family_count = result.data
          } else {
            Swal.fire('API Family Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API Family Count Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    getPeople () {
      api.getMemberCount(
        result => {
          if (result.result === true) {
            this.People_count = result.data
          } else {
            Swal.fire('API People Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API People Count Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    savepdf () {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        from: 'income',
        from_name: 'รายได้ครัวเรือน',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        sumdebt: this.sumdebt,
        sumexp: this.sumexp,
        list: this.listreport
      }
      // let payload1 = this.listreport
      // console.log(payload1)
      console.log(payload)
      console.log(document.getElementsByName('datasale')[0].value = JSON.stringify(
        payload
      ))
      // console.log(document.getElementsByName('datasale1')[0].value = JSON.stringify(
      //   payload1
      // ))
    },
    saveExcelXLSX (val) {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        from: 'income',
        from_name: 'รายได้ครัวเรือน',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        sumdebt: this.sumdebt,
        sumexp: this.sumexp,
        list: this.listreport
      }
      console.log(payload)
      document.getElementsByName('datasaleXLS')[0].value = JSON.stringify(
        payload
      )
      // document.getElementsByName('datasalexlsx')[1].value = JSON.stringify(
      //   payload
      // )
    },
    saveExcelCSV (val) {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        type: val,
        from: 'income',
        from_name: 'รายรับ',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        sumdebt: this.sumdebt,
        sumexp: this.sumexp,
        list: this.listreport
      }
      document.getElementsByName('datasaleCSV')[0].value = JSON.stringify(
        payload
      )
      // document.getElementsByName('datasalexlsx')[1].value = JSON.stringify(
      //   payload
      // )
    },
    saveExcelXLS (val) {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        type: val,
        from: 'income',
        from_name: 'รายรับ',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        sumdebt: this.sumdebt,
        sumexp: this.sumexp,
        list: this.listreport
      }
      document.getElementsByName('datasaleXLS')[0].value = JSON.stringify(
        payload
      )
      // document.getElementsByName('datasalexlsx')[1].value = JSON.stringify(
      //   payload
      // )
    },
    changetemp (val) {
      console.log(val)
      switch (val) {
        case 'y':
          this.trendline.yeartemp = this.trendline.year
          break
        case 'm':
          this.trendline.monthtemp = this.trendline.month
          break
        case 'yb':
          this.trendline.yearbeforetemp = this.trendline.yearbefore
          break
        default:
          this.trendline.monthbeforetemp = this.trendline.monthbefore
      }
    },
    changeback (val) {
      switch (val) {
        case 'y':
          this.trendline.year = this.trendline.yeartemp
          break
        case 'm':
          this.trendline.month = this.trendline.monthtemp
          break
        case 'yb':
          this.trendline.yearbefore = this.trendline.yearbeforetemp
          break
        default:
          this.trendline.monthbefore = this.trendline.monthbeforetemp
      }
    },
    getReport (val) {
      // var start = this.trendline.yearbefore + '-' + this.trendline.monthbefore + '-01'
      var start = this.trendline.yearbefore
      var month = this.trendline.monthbefore
      // var d = new Date(this.trendline.year, parseInt(this.trendline.month), 0).getDate()
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      // var end = this.trendline.year + '-' + this.trendline.month + '-' + d
      let payload = {
        'year': start,
        'month': month
      }
      console.log('year', start)
      console.log('month', month)
      this.$store.state.isLoading = true
      api.getReportFamily(
        payload,
        results => {
          if (results.result === true) {
            this.sumdebt = 0
            this.sumexp = 0
            this.sumbalnce = 0
            this.sumincome = 0
            this.listreport = results.data
            this.listreport.forEach(v => {
              v['data_income'].forEach(val => {
                this.sumdebt += parseInt(val['debt'])
                this.sumexp += parseInt(val['expenditure'])
                this.sumbalnce += parseInt(val['balance'])
                this.sumincome += parseInt(val['income'])
              })
            })
            console.log(JSON.stringify(this.listreport))
            this.changetemp(val)
            // this.test1 = this.test.data.reduce(function (r, a) {
            //   r[a.family_id] = r[a.family_id] || []
            //   console.log(a)
            //   s.data.push(a)
            //   r[a.family_id].data.push(a)
            //   console.log(s)
            //   return r
            // }, Object.create(null))
            // console.log(this.test1)
            // this.test1 = this.test.data.reduce((r, a) => {
            //   console.log('a', a)
            //   console.log('r', r)
            //   r[a.family_id] = [...r[a.family_id] || [], a]
            //   return r
            // }, {})
            // console.log('group', group)
          } else {
            this.changeback(val)
            Swal.fire('API People Count Fail!', results, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          this.changeback(val)
          Swal.fire('API Report Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    listarraybalance (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].balance)
      }
      return list
    },
    listarrayincome (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].income)
      }
      return list
    },
    listarrayexp (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].expenditure)
      }
      return list
    },
    listarraydebt (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].debt)
      }
      return list
    },
    listarraymonth (array) {
      var list = []
      for (var i in array) {
        list.push('เลขที่ ' + array[i].address_number + ' ' + 'ม.' + array[i].moo_number)
      }
      return list
    },
    income ($income, $debt, $exp, $balance, month) {
      var ctx = document.getElementById('myChartincome').getContext('2d')
      this.myChartincome = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: month,
          datasets: [
            {
              label: 'ยอดรายรับ',
              data: $income,
              backgroundColor: '#00C4FF',
              // borderColor: 'blue',
              borderWidth: 0,
              fill: true,
              spanGaps: true,
              tension: 0.5
            },
            {
              label: 'ยอดรายจ่าย',
              data: $exp,
              backgroundColor: '#D2F73B',
              // borderColor: '#D2F73B',
              borderWidth: 0,
              fill: true,
              spanGaps: true,
              tension: 0.5
            },
            {
              label: 'ยอดหนี้สิน',
              data: $debt,
              backgroundColor: '#F73B3B',
              // borderColor: '#F73B3B',
              borderWidth: 0,
              fill: true,
              spanGaps: true,
              tension: 0.5
            },
            {
              label: 'ยอดคงเหลือ',
              data: $balance,
              borderWidth: 0,
              backgroundColor: '#3BF754'
              // borderColor: '#3BF754',
              // Changes this dataset to become a line
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: false
                }
              }
            ]
          }
        }
      })
    },
    doFuncReload (value) {
      console.log('Reload', value)
      this.family_id = value.family_id
      this.getReport()
      console.log('family_id', this.family_id)
    }
  },
  mounted () {
    this.getyear()
    this.getReport()
  }
}



// WEBPACK FOOTER //
// ./src/js/incom_report.js